/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import './UserPreview.css'

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
    Spinner
} from "reactstrap";
import secureLocalStorage from "react-secure-storage";

import { useUserImage } from "../../LandingPage/Context/UserImageContext";
import { formatInitialsName } from "../../../../utils/views/pages/InitialsFormat.js"
import { postImage, putUser } from "../../../../network/ApiAxios";
import termsIcon from '../../../../assets/img/icons/common/terms-icon.svg'
import faqIcon from '../../../../assets/img/icons/common/faq-icon.svg'
import privacyIcon from '../../../../assets/img/icons/common/privacy-icon.svg'

const UserPreview = (props) => {
    const user = JSON.parse(secureLocalStorage.getItem("user"));
    const initials = formatInitialsName(user.name);
    const { imageContent, refreshImage } = useUserImage();
    const [isLoading, setisLoading] = useState(false)

    //Para carregamento da imagem do contexto 
    useEffect(() => {
        if (user.image) {
            refreshImage(user.image);
        }
    }, []);
    /**
     * Carrega a foto do usuário ao abrir a página de perfil
     * e atualiza o rendering sempre que há modificação de nova
     * imagem a carregar
     */
    // UTILIZANDO O HOOK PERSONALIZADO - useUserImage
    // useEffect(() => {
    //     loadImage()
    // }, [fileKey, imageContent]);

    // const loadImage = async () => {

    //     if (fileKey) {
    //         const response = await getImage(fileKey);
    //         const { data } = response;
    //         setImageContent(data);
    //     }
    // };

    /**
     * Atualiza o arquivo de imagem para realizar o upload no
     * servidor
     * 
     * @param {*} event 
     */
    const handleFileChange = (event) => {
        setisLoading(true)
        handleUpload(event.target.files[0])
    };

    /**
     * Envia o arquivo de imagem selecionado para o servidor, 
     * que por sua vez, envia para o S3 da AWS. Faz a atualização de dados
     * do Usuário para considerar a nova imagem associada a ele.
     * 
     * @param {*} selectedFile 
     * @returns 
     */
    const handleUpload = async (selectedFile) => {
        if (!selectedFile) {
            alert('Please select a file first!');
            return;
        }

        const reader = new FileReader();
        reader.onloadend = async () => {

            //Convertendo o arquivo de imagem para o tipo
            //esperado pelo servidor e criando
            //o JSON padrão da API no backend
            const base64Image = reader.result.split(',')[1]; // Get Base64 part                 
            let extension = selectedFile.type.split('/')[1] //Get file extension
            let params = {
                account: user.account,
                imageData: base64Image,
                fileName: selectedFile.name,
                fileType: extension,
                objectId: user._id
            }

            //Postando a imagem para o servidor de backend
            const response = await postImage(params);
            const { data } = response;

            if (data.success) {               
                const fileKey = data.imageID.toString();
                await updateUserData(fileKey)
                refreshImage(fileKey);
                setisLoading(false)
            }
        };
        reader.readAsDataURL(selectedFile);
    };

    /**
     * Atualiza os dados do usuário logado tanto
     * no servidor de backend como também na sessão
     * do navegador cliente
     */
    const updateUserData = async (fileKey) => {

        let params = {
            userID: user._id,
            name: user.name,
            email: user.email,
            image: fileKey
        }

        //Postando a imagem para o servidor de backend
        const response = await putUser(params);
        const { data } = response;

        //Atualizando os dados do usuário logado que estão na sessão do navegador
        if (data.success) {
            user.image = fileKey   //nova imagem
            secureLocalStorage.setItem("user", JSON.stringify(user));            
        }

    }

    return (
        <Col className="order-xl-2 mb-5 mb-xl-0" xl="4">
            <Card className="card-profile shadow-sm">
                <Row className="justify-content-center">


                    {isLoading ? (

                        <Spinner size="sm" className="me-2 mx-1" />
                    ) :
                        (
                            <Col className="order-lg-2 mt-3" lg="12">
                                <div className="avatar-180">


                                    {imageContent ? (
                                        <img
                                            alt="..."
                                            className="avatar-180__img"
                                            src={imageContent}
                                        />
                                    ) : (
                                        <div className="user-initials-circle">
                                            {initials}
                                        </div>
                                    )}

                                    <input
                                        type="file"
                                        accept=".jpg, .jpeg, .png, image/gif"
                                        onChange={handleFileChange}
                                        style={
                                            {

                                                width: '200px',
                                                height: '200px',
                                                opacity: 0, //1 para ver onde está
                                                position: 'absolute',
                                                zIndex: 10,
                                                cursor: 'pointer',
                                                borderStyle: 'solid',
                                                borderWidth: '1px',
                                            }
                                        } >
                                    </input>


                                </div>
                            </Col>
                        )}


                </Row>
                {/* <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                    <div className="d-flex justify-content-between">
                        <Button
                            className="mr-4"
                            color="info"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                            size="sm"
                        >
                            Connect
                        </Button>
                        <Button
                            className="float-right"
                            color="default"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                            size="sm"
                        >
                            Message
                        </Button>
                    </div>
                </CardHeader> */}
                <CardBody className="pt-0 pt-md-3">
                    <div className="text-center mt-md-3 mt-sm-2">
                        <h3>
                            {user.name}

                        </h3>
                    </div>
                    <Row>
                        <div className="col">
                            <div className="card-profile-stats d-flex justify-content-center mt-md-1">
                                <Link to="/terms" className="d-flex flex-column align-items-center">
                                    {/* Substituído o span por um ícone SVG e mantido o texto como descrição */}
                                    <img src={termsIcon} alt="Terms Icon" className="stat-icon" />
                                    <span className=" text-body">Terms</span>
                                </Link>
                                <Link to="/faq" className="d-flex flex-column align-items-center">
                                    <img src={faqIcon} alt="FAQ Icon" className="stat-icon" />
                                    <span className="text-body">FAQ</span>
                                </Link>
                                <Link to="/privacy" className="d-flex flex-column align-items-center">
                                    <img src={privacyIcon} alt="Privacy Icon" className="stat-icon" />
                                    <span className="text-body">Privacy</span>
                                </Link>
                            </div>
                        </div>
                    </Row>

                </CardBody>
            </Card>
        </Col>
    )

}

export default UserPreview;